import React from 'react'
import { StyledLiveText, StyledNames } from './ReportersLiveStyled'

export const ReportingLiveText = ({
    name1,
    name2,
}: {
    name1: string
    name2?: string
}) => {
    return (
        <StyledNames>
            {name1}{name2 ? ` and ${name2} are` : ' is'}
            <StyledLiveText> reporting live.</StyledLiveText>
        </StyledNames>
    )
}
